const closeAuthorization = async (): Promise<void> => {
  return;
};

export { closeAuthorization };
